export default __webpack_public_path__ + "static/media/shimmer.c0ed863b.png";